<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">本地安全知识</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="inside_pages_right_content_top ">
                <div class="inside_pages_right_content_top_left ">
                    <el-cascader :options="cateList" :props="{ expandTrigger:'hover'}" size="mini">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.label }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                        </template>
                    </el-cascader>
                    &nbsp;
                    <el-button size="mini" type="primary"  icon="el-icon-search" @click="$Common.pageJump('/add_safety_knowledge',3)" >新增</el-button>
                    <el-button size="mini" type="primary"  icon="el-icon-search">排序</el-button>
                    <el-button size="mini" type="primary"  icon="el-icon-search">删除</el-button>
                </div>
                <div class="inside_pages_right_content_top_right ">
                    <el-input v-model.trim="requestData.title"  size="mini" placeholder="请输入资源名称"></el-input> &nbsp;
                    <el-select v-model="requestData.fileClassification" size="mini">
                        <el-option  label="请选文件分类" value="">
                        </el-option>
                        <el-option v-for="item in $store.state.select.knowledgeCategory" :key="item.id" :label="item.nameOne" :value="item.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="inside_pages_right_content_center">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">
                    <el-table-column prop="id" label="ID">
                    </el-table-column>

                    <el-table-column prop="title" label="资源名称">
                    </el-table-column>

                    <el-table-column prop="coverPicture" label="封面图">
                        <template slot-scope="scope">
                            <el-image  class="img-thumbnail"
                                :src="$store.state.config.fileUrl+scope.row.coverPicture"
                                :preview-src-list="[$store.state.config.fileUrl+scope.row.coverPicture]">
                            </el-image>
                        </template>
                    </el-table-column>

                    <el-table-column prop="concats" label="所属分类">
                    </el-table-column>

                    <el-table-column prop="fileClassification" label="文件分类">

                        <template slot-scope="rowData">
                            {{$store.state.select.knowledgeCategory[rowData.row.fileClassification].nameOne}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="releaseTime" label="发布时间">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDateTwo(rowData.row.releaseTime)}}
                        </template>
                    </el-table-column>

                    <el-table-column  label="操作">
                        <template slot-scope="scope">
                            <el-button  type="primary" plain  size="mini"   icon="el-icon-document">
                                预览
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="inside_pages_right_content_bottom">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
            requestData:{
                pageNum:1,
                pageSize:20,
                schoolId:this.$store.state.schoolId,
                title:'',
                fileClassification:'',
                resourceClassification:'',
            },
            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[],       // 数据列表
            },
            cateList:[],


        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            this.requestData.pageSize = pageNum
            this.getDataList()

        },
        handleCurrentChange(val) {
            this.requestData.pageSize = val
            this.getDataList()
        },
        // 获取类别
        async getCate(){
			var newParamData = {
                schoolId:this.$store.state.schoolId,
            }
			let res = await  this.$Http.getResourceClassification(newParamData,true)
			if(res.code == 200){
                if(res.data.length>=1){
                    this.cateList = []
                    for(var keyOne in res.data){
                        var sonDataList = []
                        for(var keyTwo in res.data[keyOne].resourceClassificationLists){
                            sonDataList.push({
                                value: keyOne + '-' + keyTwo,
                                label: res.data[keyOne].resourceClassificationLists[keyTwo].subclassificationName,
                                thisId: res.data[keyOne].resourceClassificationLists[keyTwo].id,
                                thisLevel: 2,
                            })
                        }
                        this.cateList.push({
                            value: keyOne,
                            label: res.data[keyOne].fatherNode,
                            thisId: res.data[keyOne].id,
                            thisLevel: 1,
                            children:sonDataList,
                        })
                    }
                }
                // console.log(this.cateList)
            }else if(res.code == 101){

            } else {
                // this.$message({
                //     type: 'error',
                //     message: res.messsage
                // });
            }
        },

        // 获取数据列表
        async getDataList(){
            let res =  await this.$Http.getLocaSafetyKnowledge(this.requestData,true)
            if(res.code == 200){
                this.responseData.pageSize = res.data.pageSize;
                this.responseData.pageNum = res.data.pageNum;
                this.responseData.total = res.data.total;
                this.responseData.pages = res.data.pages;
                this.responseData.list = res.data.list;
                // console.log(this.responseData.list)
            }else if(res.code == 101){

            } else {
                // this.$message({
                //     type: 'error',
                //     message: res.messsage
                // });
            }
        },

    },
    created() {},
    mounted() {
        this.getDataList()
        this.getCate()
    }
};
</script>
